import React, { useState } from 'react';
import './Contact.css';
import contactImage from '../../assest/ExamSify Contact Image.png';

const Contact = () => {
  const [showPopup, setShowPopup] = useState(false);
  const [status, setStatus] = useState("");

  const [formData, setFormData] = useState({
    contactname: "",
    contactemail: "",
    contactnumber: "",
    userType: "teacher",
    contactcategory: "Solution Related",
    contactmessage: ""
  });

  const handleChange = (e) => {
    setFormData(prev => ({
      ...prev,
      [e.target.id]: e.target.value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const phoneRegex = /^\d{10}$/;
    if (!phoneRegex.test(formData.contactnumber)) {
      setStatus('Please enter a valid 10-digit mobile number.');
      return;
    }

    setShowPopup(true);
    try {
      //const res = await fetch("http://localhost:8004/api/examsify-contact", { //Uncomment this line if you have a backend server running locally
      const res = await fetch("https://cz-engine.onrender.com/api/examsify-contact", {
      method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(formData)
      });

      const result = await res.json();
      if (res.ok) {
        setFormData({
          contactname: "",
          contactemail: "",
          contactnumber: "",
          userType: "teacher",
          contactcategory: "Solution Related",
          contactmessage: ""
        });
        setStatus(""); // Clear error after successful submit
      } else {
        alert("Error: " + result.error);
      }
    } catch (err) {
      console.error(err);
      alert("Something went wrong!");
    }
  };

  return (
    <div className="contact-container">
      <div className="contact-left">
        <img src={contactImage} alt="Contact" />
      </div>

      <div className="contact-right">
        <h1>Contact ExamSify</h1>
      </div>

      <div className="contact-form-wrapper">
        <form className="contact-form" onSubmit={handleSubmit}>
          <div className="input-group">
            <label htmlFor="contactname">Your Name</label>
            <input
              className="input-field"
              type="text"
              id="contactname"
              value={formData.contactname}
              placeholder="First name"
              onChange={handleChange}
            />
          </div>

          <div className="input-group">
            <label htmlFor="contactemail">Your Email</label>
            <input
              className="input-field"
              type="email"
              id="contactemail"
              value={formData.contactemail}
              placeholder="Email address"
              onChange={handleChange}
            />
          </div>

          <div className="input-group">
            <label htmlFor="contactnumber">Cell Number</label>
            <input
              className="input-field"
              type="tel"
              id="contactnumber"
              value={formData.contactnumber}
              placeholder="Enter number"
              onChange={(e) => {
                handleChange(e);
                setStatus("");
              }}
              required
            />
            {status && <p className="error-msg">{status}</p>}
          </div>

          <fieldset>
            <legend>Are You?</legend>
            <label className='contact-label'>
              <input
                type="radio"
                name="userType"
                id="userType"
                value="parent"
                checked={formData.userType === "parent"}
                onChange={handleChange}
              />{" "}
              A Parent
            </label>
            <label className='contact-label'>
              <input
                type="radio"
                name="userType"
                id="userType"
                value="student"
                checked={formData.userType === "student"}
                onChange={handleChange}
              />{" "}
              A Student
            </label>
            <label className='contact-label'>
              <input
                type="radio"
                name="userType"
                id="userType"
                value="teacher"
                checked={formData.userType === "teacher"}
                onChange={handleChange}
              />{" "}
              A Teacher
            </label>
          </fieldset>

          <div className="input-group">
            <label htmlFor="contactcategory">Category</label>
            <select
              className="input-field"
              id="contactcategory"
              value={formData.contactcategory}
              onChange={handleChange}
               required
            >
              <option>Solution Related</option>
              <option>Questions Related</option>
              <option>AI Related</option>
              <option>Others</option>
            </select>
          </div>

          <div className="input-group">
            <label htmlFor="contactmessage">How Can We Help?</label>
            <textarea
              id="contactmessage"
              className="input-field"
              value={formData.contactmessage}
              placeholder="Please summarise the problem"
              onChange={handleChange}
               required
            ></textarea>
          </div>

          <div className="form-actions">
            <button type="button" className="cancel-btn-contact">Cancel</button>
            <button type="submit" className="submit-btn-contact">Submit</button>
          </div>
        </form>
      </div>

      {showPopup && (
        <div className="popup-overlay">
          <div className="popup-box">
            <h2>Thank you!</h2>
            <p>Thank you for contacting Examsify</p>
            <button className='contact-popup-button' onClick={() => setShowPopup(false)}>Close</button>
          </div>
        </div>
      )}
    </div>
  );
};

export default Contact;
